import React, { Component } from "react";
import * as pr from "../../common/PrimeComponents";
import * as Log from "../../common/Feedback/Log";
import { ValidateState, CrudlStatus } from "../../common/config/AppConstants";

export class MVVMValidateDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: null,
      errors: []
    };

    this.logger = Log;
  }

  setPreviousCrudl = () => {
    this.props.updateVisibility("crudlState", CrudlStatus.UPDATE);
  };
  updateVisibility = (key, value) => {
    if (this.props.type === "CRUDL") {
      this.setPreviousCrudl();
    }
    this.props.updateVisibility(key, value);
  };

  runConfirm = key => {
    if (this.props.type === "CRUDL") {
      this.props.crudlExecute(this.props.crudlStatus);
    } else {
      this.props.runConfirm();
    }
    this.updateVisibility(key, ValidateState.NONE);
  };

  render() {
    return (
      <div>
        <pr.Dialog
          header={this.props.header}
          footer={
            <div>
              <pr.Button
                className="secondary-btn"
                label="Yes"
                icon="pi pi-check"
                onClick={() => {
                  this.runConfirm(this.props.visibleField);
                }}
                style={{
                  backgroundColor: "black",
                  color: "white",
                  float: "right"
                }}
              />
              <pr.Button
                className="secondary-btn"
                label="No"
                icon="pi pi-times"
                onClick={() => {
                  this.updateVisibility(
                    this.props.visibleField,
                    ValidateState.NONE
                  );
                }}
                style={{
                  backgroundColor: "black",
                  color: "white",
                  float: "right"
                }}
              />
            </div>
          }
          visible={this.props.isVisible}
          style={{ width: "50vw", backgroundColor: "#043066", color: "white" }}
          modal={true}
          onHide={e =>
            this.updateVisibility(this.props.visibleField, ValidateState.NONE)
          }
        >
          {this.props.message}
        </pr.Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/MVVMValidateDialog.js